import React, { ForwardedRef, forwardRef } from 'react'

import classNames from 'classnames'

import styles from './PlaceSection.module.scss'

type Props = {
  children: React.ReactNode
  className?: string
  sectionClassName?: string
  isNoPaddingHorizontal?: boolean
  isTransparentBg?: boolean
  style?: React.CSSProperties
  role?: string
}
function PlaceSection(
  { children, className, sectionClassName, isNoPaddingHorizontal, isTransparentBg, ...props }: Props,
  ref?: ForwardedRef<HTMLDivElement>,
) {
  return (
    <div
      ref={ref}
      className={classNames(styles.section_wrapper, className, { [styles.type_transparent_bg]: isTransparentBg })}
      {...props}
    >
      <div
        className={classNames(styles.section, sectionClassName, { [styles.type_no_padding]: isNoPaddingHorizontal })}
      >
        {children}
      </div>
    </div>
  )
}

export default forwardRef(PlaceSection)
